import { render, staticRenderFns } from "./ImportStatusWrapper.vue?vue&type=template&id=af9f6794&scoped=true&"
import script from "./ImportStatusWrapper.vue?vue&type=script&lang=ts&"
export * from "./ImportStatusWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9f6794",
  null
  
)

export default component.exports